// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2_DKc","head":"Table_head__278vl","col":"Table_col__23zTQ"};